module.exports = __WEBPACK_EXTERNAL_MODULE_120__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
 ** module id = 120
 ** module chunks = 0
 **/